import Vue from "vue";
import DocumentsTable from "../components/tables/DocumentsTable";

Vue.component('documents-listing', {
    components: { DocumentsTable },
    data() {
        return {
            vueAppErrors:[]
        }
    },
    methods: {
        onVueAppErrors(errors) {
            this.vueAppErrors = errors;
        }
    },
    props: {
        vesselId: {
            required: true,
            type: Number
        }
    }
});